import { render, staticRenderFns } from "./eComplaintNewComment.vue?vue&type=template&id=f8d3a7e0"
import script from "./eComplaintNewComment.vue?vue&type=script&lang=js"
export * from "./eComplaintNewComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports